import React, { useEffect, useRef } from "react";
import "../../css/TaskReference.css";

const PRIORITY_COLORS = {
  URGENT: "#e55b5b",
  HIGH: "#f5a623",
  MEDIUM: "#5B92E5",
  LOW: "#7ED321",
  NONE: null,
};

const PRIORITY_LABELS = {
  URGENT: "Urgent",
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  NONE: null,
};

function TaskReferenceDropdown({
  isOpen,
  query,
  results,
  loading,
  position,
  highlightIndex,
  onSelect,
  onClose,
}) {
  const dropdownRef = useRef(null);
  const highlightedRef = useRef(null);

  // Scroll highlighted item into view
  useEffect(() => {
    if (highlightedRef.current) {
      highlightedRef.current.scrollIntoView({ block: "nearest" });
    }
  }, [highlightIndex]);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      className="TaskReference__dropdown"
      style={{
        position: "fixed",
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 99999,
      }}
    >
      <div className="TaskReference__dropdown-header">
        <i className="fas fa-tasks"></i>
        <span>Link a task</span>
        {query && <span className="TaskReference__dropdown-query">#{query}</span>}
      </div>

      {loading && results.length === 0 && (
        <div className="TaskReference__dropdown-loading">Searching...</div>
      )}

      {!loading && query.length >= 2 && results.length === 0 && (
        <div className="TaskReference__dropdown-empty">No tasks found</div>
      )}

      {!loading && query.length < 2 && results.length === 0 && (
        <div className="TaskReference__dropdown-hint">
          Type a task ID (e.g. BBTM-42) or search by title
        </div>
      )}

      {results.length > 0 && (
        <div className="TaskReference__dropdown-results">
          {results.map((task, idx) => (
            <div
              key={task.id}
              ref={idx === highlightIndex ? highlightedRef : null}
              className={`TaskReference__dropdown-item ${
                idx === highlightIndex ? "TaskReference__dropdown-item--active" : ""
              }`}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(task);
              }}
              onMouseEnter={() => {}}
            >
              <span className="TaskReference__dropdown-item-id">
                {task.board_task_id}
              </span>
              <span className="TaskReference__dropdown-item-title">
                {task.title}
              </span>
              <div className="TaskReference__dropdown-item-meta">
                {PRIORITY_LABELS[task.priority] && (
                  <span
                    className="TaskReference__dropdown-item-priority"
                    style={{
                      color: PRIORITY_COLORS[task.priority],
                      borderColor: PRIORITY_COLORS[task.priority],
                    }}
                  >
                    {PRIORITY_LABELS[task.priority]}
                  </span>
                )}
                <span className="TaskReference__dropdown-item-board">
                  {task.board_name}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TaskReferenceDropdown;
